const codeModule = {
  "101": "データを受け取りません",
  "102": "サイン認証に失敗しました、再登録してください",
  "103": "認証コードの発送に失敗しました",
  "104": "携帯番号を入力してください",
  "105": "パスワードを入力してください",
  "106": "携帯番号は登録済です",
  "111": "登録失敗",
  "107": "認証コードミス",
  "108": "ユーザー名とパスワードが一致しません",
  "109": "ユーザー名がありません",
  "110": "パスワードの変更に失敗しました",
  "112": "ログアウト失敗",
  "113": "ユーザー情報の変更に失敗しました",
  "114": "パラメータ",
  "115": "保存失敗",
  "121": "クレジットカード情報が足りません",
  "122": "このIDが見つかりませんでした",
  "201": "店舗がありません",
  "202": "席がありません",
  "203": "表現を変更したほうが良いと感じました",
  "204": "ユーザーはいかなる店舗でも消費したことがありません",
  "205": "グルメがありません",
  "206": "営業時間以外となります",
  "301": "商品が見つかりません",
  "302": "商品がありません",
  "303": "売り切れ",
  "304": "お勧めセットの利用人数を入力してください",
  "305": "商品がありません",
  "306": "お勧めセットがありません",
  "307": "店内飲食対応していません",
  "308": "配達/テイクアウト対応していません",
  "309": "一部の商品は売り切れています",
  "401": "宅配住所がありません",
  "403": "配達エリア外のため 注文をお受けできません",
  "404": "カートに商品がありません",
  "405": "食事人数を入力してください",
  "407": "席を選択してください",
  "408": "席がロックされています",
  "409": "最低の宅配費用になりません",
  "410": "総金額は1円以上が必要です",
  "411": "注文追加に失敗しました、もう一度お試しください",
  "412": "注文がありません",
  "413": "当注文は支払済となります",
  "415": "注文にコメントしました",
  "416": "評価をお願いします",
  "417": "コメント失敗、もう一度お試しください",
  "418": "領収書に印刷しました",
  "419": "印刷失敗",
  "420": "会社名を入力してください",
  "421": "注文にコメントしていません",
  "422": "支払済の注文が取消できません",
  "423": "取消失敗",
  "424": "当注文に操作する権限がありません",
  "425": "受入失敗",
  "426": "支払済の場合料理追加はできません。",
  "427": "クレジットカード情報エラー",
  "428": "支払失敗、チェックして再試行してください",
  "429": "今はお持ち帰りの時間ではありません",
  "430": "今は配達の時間ではありません",
  "431": "利用不可のペイメント",
  "433": "只今受付時間外となります",
  "501": "該当クーポンは存在しません",
  "502": "該当クーポンの発行枚数が上限に達しました",
  "503": "一人当たり受領可能な枚数を超えています",
  "504": "受領失敗。もう一度お試しください",
  "505": "クーポンは利用済または時間切れです",
  "506": "使用条件を満たしていません（クーポン詳細をご確認ください）",
  "1000": "カートから削除ください!",
  "1001": "受取の確認しました"
};

export default codeModule;
